module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_x-1-PART-title-1"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/section0005"
    }
  }, [_vm._v("Part 1")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_x-2-PART-head-1"
  }, [_c('span')]), _vm._v(" "), _c('p', {
    staticClass: "P_x-2-PART-head-1"
  }, [_c('span', [_vm._v("Setting the Scene")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("The scene was set in Dallas long before John Kennedy visited there on November 22, 1963. During the immediate post-World War II era, the country had struggled as it tried to find and identify its Cold War posture. We had reached a consensus to have a strong and united front to combat the Soviet Union.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("We also tried to cope with a new fear, a fear that the world could destroy itself. Americans worried about a world-ending catastrophe if the country wasn’t vigilant enough or that it may also occur if we provoked a confrontation that would lead to a most different kind of war.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("America turned to charismatic leaders. Amid nuclear nightmares, people had the strongest need to feel safe.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("The country looked to John Kennedy and others to be respected father-figures who somehow had the wisdom to make all the right decisions. Then maybe the nightmares could all go away.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("Instead, a living nightmare unfolded in Dallas.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35038beb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0008.vue
// module id = 78
// module chunks = 0